import React from "react";
import CreateCruiseWorkflow from "./CreateCruiseWorkflow";
import { useCruise } from "@/context/CruiseContext";
import { TESTIDS } from "@/lib/testIds";

/**
 * CreateCruiseRoute — dedicated `#cruises/new` route wrapper for the
 * Create Cruise Workflow. Restored + modernized from the deleted
 * NewCruiseRoute.jsx (Foundation Freeze, 2026-07-15).
 *
 * ADR-CRUISE-001 · The Cruises workspace owns the cruise lifecycle.
 * Dismissing or completing this workflow returns the user there.
 */
export default function CreateCruiseRoute() {
  const { setRoute, reloadVoyage } = useCruise();

  const dismiss = () => {
    // Return to the cruise portfolio whether the user completed the
    // workflow or dismissed it.
    setRoute("voyages");
  };

  const onCreated = async () => {
    // Refresh voyage context so the new cruise (if activated) is
    // reflected immediately. ProvisioningCard owns the transition to
    // the voyage dashboard.
    try {
      await reloadVoyage?.();
    } catch { /* silent */ }
  };

  return (
    <div
      className="min-h-[calc(100vh-var(--cc-topbar-h,0px))]"
      data-testid={TESTIDS.createCruiseRoute}
    >
      <CreateCruiseWorkflow onClose={dismiss} onCreated={onCreated} />
    </div>
  );
}
